import React from "react"
import get from "lodash/get"
import moment from "moment"
import { withPropsOnChange } from "recompact"
import DatePicker from "../components/DatePicker"
import formatWeekDate from "../helpers/formatWeekDate"
import {
  SCALE_FORMAT_MASKS,
  USER_SCALES,
  RC_CALENDAR_MODE_NAMES,
} from "../constants"

export default withPropsOnChange(
  [`calendarStartTime`, `calendarEndTime`, `calendarScale`, `plan`],
  ({ calendarStartTime, calendarEndTime, calendarScale, queryApi, plan }) => {
    const centerTime =
      calendarStartTime + (calendarEndTime - calendarStartTime) / 2

    const options = USER_SCALES.map(scale => ({
      value: scale,
      label: RC_CALENDAR_MODE_NAMES[scale],
    }))
    const option = options
      .sort((a, b) => b.value - a.value) // So options.find can find the elem with a greatest value
      .find(option => calendarScale >= option.value)

    const formatMask = SCALE_FORMAT_MASKS[option.value]

    const time = moment(centerTime)
    const placeholder =
      option.label === `week` ? formatWeekDate(time) : time.format(formatMask)

    return {
      currentTimeText: (
        <DatePicker
          mode={option.label}
          defaultValue={time}
          calendarScale={calendarScale}
          placeholder={placeholder}
          queryApi={queryApi}
          minDate={get(plan, `data.startDateTime`)}
          maxDate={get(plan, `data.endDateTime`)}
        />
      ),
    }
  },
)
